import type { AppKitNetwork } from '@reown/appkit/networks'
import { bsc, hardhat } from '@reown/appkit/networks'
import { defineChain } from 'thirdweb'

// Get projectId from https://cloud.reown.com
export const projectId = '0615b90f13719639d67f15ee7b7f9289'

export const localHardhatChain = defineChain({
    id: 31337,
    name: 'Hardhat Localhost',
    rpcUrls: {
        default: {
            http: ['http://127.0.0.1:8545'],
        },
    },
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    testnet: true,
})

export const networks = [hardhat, bsc] as [AppKitNetwork, ...AppKitNetwork[]]
